export default __webpack_public_path__ + "static/media/support-notes-main-real-state.a25e1049.png";